import React from "react";
import PropTypes from "prop-types";
import { LoaderCircle } from "lucide-react";

const Skeleton = ({ className = "" }) => <span className={`wsm-skeleton ${className}`.trim()} />;

Skeleton.propTypes = { className: PropTypes.string };

const PackViewSkeleton = () => (
  <div aria-busy="true" aria-label="Loading worksite pack" className="wsm-pack-view-skeleton" role="status">
    <div aria-hidden="true" className="wsm-pack-view-skeleton__visual">
      <div className="wsm-pack-view-skeleton__status"><LoaderCircle />Loading worksite pack</div>

      <header className="wsm-pack-view-skeleton__header">
        <Skeleton className="wsm-pack-view-skeleton__breadcrumb" />
        <div className="wsm-pack-view-skeleton__header-row">
          <div className="wsm-pack-view-skeleton__identity">
            <div className="wsm-pack-view-skeleton__title-row">
              <Skeleton className="wsm-pack-view-skeleton__title" />
              <Skeleton className="wsm-pack-view-skeleton__badge" />
            </div>
            <div className="wsm-pack-view-skeleton__metadata">
              {Array.from({ length: 3 }, (_, index) => <Skeleton key={index} />)}
            </div>
          </div>
          <div className="wsm-pack-view-skeleton__actions">
            <Skeleton /><Skeleton /><Skeleton />
          </div>
        </div>
      </header>

      <div className="wsm-pack-view-skeleton__tabs">
        <Skeleton /><Skeleton /><Skeleton />
      </div>

      <div className="wsm-pack-view-skeleton__jump-links">
        {Array.from({ length: 5 }, (_, index) => <Skeleton key={index} />)}
      </div>

      <section className="wsm-pack-view-skeleton__overview">
        <Skeleton className="wsm-pack-view-skeleton__section-title" />
        <Skeleton className="wsm-pack-view-skeleton__section-copy" />
        <div className="wsm-pack-view-skeleton__grid">
          {Array.from({ length: 8 }, (_, index) => (
            <div key={index}><Skeleton /><Skeleton /></div>
          ))}
        </div>
      </section>

      <div className="wsm-pack-view-skeleton__sections">
        {Array.from({ length: 2 }, (_, index) => <div key={index}><Skeleton /><Skeleton /></div>)}
      </div>
    </div>
  </div>
);

export default PackViewSkeleton;
